import { useState } from 'react'

export interface SortingInterface<T> {
  /**
   * Função que deve ser chamada quando o usuário deseja ordenar
   * alguma coluna da tabela. A coluna deve ser informada ao chamá-la
   */
  onSorting: (columnName: T) => void
  /**
   * Quando verdadeiro indica que a ordem é decrescente, do contrário
   * a ordem é considerada crescente. Se altera automaticamente a partir
   * do clique do usuário
   */
  isDesc: boolean
  /**
   * Texto único contendo um identificador da coluna selecionada para ordenação
   */
  selectedColumn: T | null
}

export const useSorting = <T extends string>(): SortingInterface<T> => {
  const [selectedColumn, setSelectedColumn] = useState<T | null>(null)
  const [isDesc, setIsDesc] = useState(false)

  const onSorting = (columnName: T | null): void => {
    setSelectedColumn(columnName)
    setIsDesc(x => !x)
  }

  return { selectedColumn, isDesc, onSorting }
}
